import { motion } from "framer-motion";
import { forwardRef } from "react";
import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { Spinner } from "../Spinner/Spinner.js";
import { StyledIconButton } from "./IconButton.style.js";
import { DefaultIconButtonProps, IconButtonProps } from "./IconButton.types.js";

const defaultProps: DefaultIconButtonProps = {
    color: "primary",
    size: "medium",
    rounded: false,
    loading: false,
    variant: "fill",
};

const iconSizeMap: Record<NonNullable<IconButtonProps["size"]>, (typeof ICONSAX_SIZE)[keyof typeof ICONSAX_SIZE]> = {
    small: ICONSAX_SIZE.SMALL,
    medium: ICONSAX_SIZE.LARGE,
    large: ICONSAX_SIZE.LARGE,
};

const AnimatedIconWrapper = motion.div;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
    const {
        icon: Icon,
        size,
        loading,
        variant,
        disabled,
        animation,
        ...attributes
    } = {
        ...defaultProps,
        ...props,
    };
    const iconSize = iconSizeMap[size ?? "medium"];

    return (
        <StyledIconButton {...attributes} disabled={disabled || loading} size={size} ref={ref} variant={variant}>
            <div>
                {loading ? (
                    <Spinner />
                ) : (
                    <AnimatedIconWrapper {...(animation || {})}>
                        <Icon size={iconSize} />
                    </AnimatedIconWrapper>
                )}
            </div>
        </StyledIconButton>
    );
});
